import React, { Component } from "react";
import PmgTeamSidebar from "./PmgTeamSidebar";
import { connect } from "react-redux";
import {
  PmgInvestListing,
  SectionListing
} from "../reusableComponent/cmsManagement";
import { Image, Form } from "react-bootstrap";
import { DpiitListing } from "../reusableComponent/cmsManagement";
import Update from "../reusableComponent/cmsManagement/pmgUp/Update";
import { getHeadingAction1 } from "../../../src/actions/pmgTeam.action";
// import store from '../../../src/store';
import { LoaderPage } from "../../component/Loader";
import { PmgTeamDropDownOptions } from "../reusableComponent";
import { getHeadingg } from "../../services/apiServices";
import request from "../../services/requestService";
import ResourceIcon from "../../assets/Resource_Menu.svg";
import documentIcon from "../../assets/icon-document.png";
import Arrow from "../../assets/arrow-pointing.svg";
import Notification from "../reusableComponent/cmsResources/Notifications/Notification";
import Articles from "../reusableComponent/cmsResources/Articles/Articles";
import { BestPractices } from "../userManagement";
import { MonthlyNewsLetterComponent } from "../mis/Documents/MonthlyNewsLetter";
import { DownloadManualComponent } from "../mis/downloadUserManual";
import { getLocalstorage } from "../../helper.js";
class PmgTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "PMG Invest India",
      showLoader: true,
      newPMGupdate: "",
      Sectiontitle: "",
      Dpiittitle: "",
      Pmginvesttitle: "",
      NotificationsTitle: "",
      BestPracticesTitle: "",
      sectionmenudisplay: 0,
      newsubDropdown: PmgTeamDropDownOptions,
      underMaintenance: false,
      loading: true,
      resourcesMenudisplay: false,
      dragandDropAccess: "",
      cmsDocuments: false
    };
  }

  handleGroupManagementActions = (key, index) => {
    console.log(key);
    this.setState({
      selectedTab: key
    });
  };
  openNotification = () => {
    this.setState({ selectedTab: "Notifications" });
  };
  openBestPractices = () => {
    this.setState({ selectedTab: "Best Practices" });
  };
  openArticles = () => {
    this.setState({ selectedTab: "Articles" });
  };
  openMonthlyNewsletter = () => {
    this.setState({ selectedTab: "Monthly Newsletter" });
  };
  openUserManual = () => {
    this.setState({ selectedTab: "User Manual" });
  };
  closeResourcesMenu = () => {
    this.setState({ resourcesMenudisplay: false });
  };
  openResourcesMenu = () => {
    this.setState({ resourcesMenudisplay: true });
  };
  openDocuments = () => {
    this.setState({ cmsDocuments: true });
  };
  closeDocuments = () => {
    this.setState({ cmsDocuments: false });
  };
  async componentDidMount() {
    await this.props.getHeadingAction1();
    const response1 = await request(getHeadingg());
    this.setState({
      Dpiittitle: response1.data.data.dropDown[0].title,
      Pmginvesttitle: response1.data.data.dropDown[1].title,
      selectedTab: response1.data.data.dropDown[1].title,
      Sectiontitle: response1.data.data.dropDown[2].title
    });
  }
  handlePMGUpdateChange = data => {
    this.setState({ newPMGupdate: data });
  };
  handleSectionChange = (data, title) => {
    this.setState({
      newsubDropdown: data,
      selectedTab: title,
      Sectiontitle: title
    });
  };
  handleDPIITChange = (data, title) => {
    this.setState({
      newsubDropdown: data,
      selectedTab: title,
      Dpiittitle: title
    });
  };
  handlePMGInvestChange = (data, title) => {
    this.setState({
      newsubDropdown: data,
      selectedTab: title,
      Pmginvesttitle: title
    });
  };

  handleNotificationChange = (data, title) => {
    this.setState({
      newsubDropdown: data,
      selectedTab: title,
      NotificationsTitle: title
    });
  };
  componentDidUpdate(prevProps) {
    if (this.props.headingDetailsData !== prevProps.headingDetailsData) {
      this.setState({
        selectedTab: this.props.headingDetailsData.dropDown[1].title,
        showLoader: false,
        dragandDropAccess: this.props.headingDetailsData.isHeaderEditable
      });
    }
  }

  render() {
    const {
      selectedTab,
      resourcesMenudisplay,
      dragandDropAccess,
      cmsDocuments
    } = this.state;

    const isUserPMG = getLocalstorage("groupCategory") === "PMG";

    return (
      <>
        <LoaderPage loading={this.state.showLoader} />
        <div className="workflow">
          <div className="mis-wrapper">
            <div className="mis-sidebar group-management">
              <PmgTeamSidebar
                selectedTab={selectedTab}
                handleGroupManagementActions={this.handleGroupManagementActions}
                newPMGTitle={this.state.newPMGupdate}
                SectionTitle={this.state.Sectiontitle}
                DPIITtitle={this.state.Dpiittitle}
                PMGInvesttitle={this.state.Pmginvesttitle}
                sectionmenudisplay={this.state.sectionmenudisplay}
                newsubDropdown={this.state.newsubDropdown}
              />
              <div>
                <div
                  class="heading-cms cms-sidebar-title resources-menu"
                  data-index="2"
                  id="Resources"
                  onClick={
                    resourcesMenudisplay
                      ? this.closeResourcesMenu
                      : this.openResourcesMenu
                  }
                >
                  <span
                    class="group-management cms-sidebar-heading"
                    style={{ marginRight: "12px" }}
                  >
                    <Image
                      src={ResourceIcon}
                      style={{ marginLeft: "2px" }}
                      className="pl-2 pb-1"
                    />
                  </span>
                  <div id="Resources" class="heading_title">
                    Resources
                  </div>
                </div>
                {resourcesMenudisplay ? (
                  <>
                    <div
                      data-title="Best Practices"
                      class={
                        selectedTab == "Best Practices"
                          ? "submenu-cms resources-submenu"
                          : "submenu-cms "
                      }
                      id="Best Practices"
                      onClick={this.openBestPractices}
                      style={{ width: "95.5%", paddingLeft: "54px" }}
                    >
                      <span class=" group-managements" id="Best Practices">
                        <Image src={Arrow} id="Best Practices" class="" />
                      </span>
                      Best Practices{" "}
                    </div>
                    <div
                      data-title="Notifications"
                      class={
                        selectedTab == "Notifications"
                          ? "submenu-cms resources-submenu"
                          : "submenu-cms "
                      }
                      id="Notifications"
                      onClick={this.openNotification}
                      style={{ width: "95.5%", paddingLeft: "54px" }}
                    >
                      <span class=" group-managements" id="Notifications">
                        <Image src={Arrow} id="Notifications" class="" />
                      </span>
                      Notifications{" "}
                    </div>
                    <div
                      data-title="Articles"
                      class={
                        selectedTab == "Articles"
                          ? "submenu-cms resources-submenu"
                          : "submenu-cms "
                      }
                      id="Articles"
                      onClick={this.openArticles}
                      style={{ width: "95.5%", paddingLeft: "54px" }}
                    >
                      <span class=" group-managements" id="Articles">
                        <Image src={Arrow} id="Articles" class="" />
                      </span>
                      Articles{" "}
                    </div>
                  </>
                ) : null}
                <div
                  class="heading-cms cms-sidebar-title resources-menu"
                  data-index="2"
                  id="Resources"
                  onClick={
                    cmsDocuments ? this.closeDocuments : this.openDocuments
                  }
                >
                  <span
                    class="group-management cms-sidebar-heading"
                    style={{ marginRight: "12px" }}
                  >
                    <Image
                      src={documentIcon}
                      style={{ marginLeft: "2px", width: "24px" }}
                      className="pl-2 pb-1"
                    />
                  </span>
                  <div id="Resources" class="heading_title">
                    Documents
                  </div>
                </div>
                {cmsDocuments ? (
                  <>
                    <div
                      data-title="Monthly Newsletter"
                      class={
                        selectedTab == "Monthly Newsletter"
                          ? "submenu-cms resources-submenu"
                          : "submenu-cms "
                      }
                      id="Monthly Newsletter"
                      onClick={this.openMonthlyNewsletter}
                      style={{ width: "95.5%", paddingLeft: "54px" }}
                    >
                      <span class=" group-managements" id="Monthly Newsletter">
                        <Image src={Arrow} id="Monthly Newsletter" class="" />
                      </span>
                      Monthly Newsletter{" "}
                    </div>
                    <div
                      data-title="User Manual"
                      class={
                        selectedTab == "User Manual"
                          ? "submenu-cms resources-submenu"
                          : "submenu-cms "
                      }
                      id="Notifications"
                      onClick={this.openUserManual}
                      style={{ width: "95.5%", paddingLeft: "54px" }}
                    >
                      <span class=" group-managements" id="Notifications">
                        <Image src={Arrow} id="Notifications" class="" />
                      </span>
                      User Manual{" "}
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          <div
            className={`workflow-wrapper ${
              selectedTab === "Draft User" ? "workflow-wrapper-draft" : ""
            }`}
          >
            {selectedTab === "PMG Team" ? <DpiitListing /> : <React.Fragment />}
            {this.state.Pmginvesttitle == selectedTab ? (
              <>
                <PmgInvestListing
                  selectedTab={selectedTab}
                  onPMGInvestChange={this.handlePMGInvestChange}
                />
              </>
            ) : null}

            {this.state.Dpiittitle == selectedTab ? (
              <>
                <DpiitListing
                  selectedTab={selectedTab}
                  onDPIITChange={this.handleDPIITChange}
                />
              </>
            ) : null}

            {this.state.Sectiontitle == selectedTab ? (
              <>
                <SectionListing
                  selectedTab={selectedTab}
                  onSectionChange={this.handleSectionChange}
                />
              </>
            ) : null}
            {selectedTab == "Notifications" ? (
              <Notification
                selectedTab={selectedTab}
                dragandDropAccess={dragandDropAccess}
              />
            ) : null}
            {selectedTab == "Articles" ? <Articles /> : null}
            {selectedTab == "Best Practices" ? <BestPractices /> : null}
            {selectedTab == "Monthly Newsletter" ? (
              <MonthlyNewsLetterComponent />
            ) : null}
            {selectedTab == "User Manual" ? <DownloadManualComponent /> : null}
            {/* {String(selectedTab) === String(this.props.headingDetailsData && this.props.headingDetailsData.dropDown && this.props.headingDetailsData.dropDown.length > 0 && this.props.headingDetailsData.dropDown[1].title !== undefined ? this.props.headingDetailsData.dropDown[1].title : '') ? (
            <PmgInvestListing />
          ) : (
            <React.Fragment />
          )}*/}

            {String(selectedTab) ===
            String(
              this.props.headingDetailsData &&
                this.props.headingDetailsData.pmgUpdate &&
                this.props.headingDetailsData.pmgUpdate.title
            ) ? (
              <Update
                // setSelectedTab={data => {
                //   this.setState({
                //     selectedTab: data
                //   });
                // }}
                selectedTab={selectedTab}
                pemcilIcondisplay={true}
                headingTitle={String(
                  this.props.headingDetailsData &&
                    this.props.headingDetailsData.pmgUpdate &&
                    this.props.headingDetailsData.pmgUpdate.title
                )}
                onPMGUpdateChange={this.handlePMGUpdateChange}
              />
            ) : (
              <React.Fragment />
            )}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    headingDetailsData: state.pmgReducer.headingDetailsData,
    headingSelectedTab:
      state && state.pmgreducer && state.pmgreducer.headingSelectedTab
  };
}

export default connect(
  mapStateToProps,
  {
    getHeadingAction1
  }
)(PmgTeam);
